import {CircleUserRound} from "lucide-react";
import Image from "next/image";
import React from "react";
import {cn} from "@/lib/utils";

export function UserBadge({userImage, className}: { userImage: string | undefined | null, className?: string }) {
  if (!userImage) {
    return <UserPlaceholderBadge className={className}/>
  }
  return <Image unoptimized src={userImage}
                className={cn("rounded-full size-6", className)} width="500" height="500" alt="user image"/>
}

export default function UserPlaceholderBadge({className}: { className?: string }) {
  return <div className={cn("size-6 flex justify-center items-center", className)}>
    <CircleUserRound className={cn("text-slate-500 size-6", className)}/>
  </div>
}